module.exports = __webpack_public_path__ + "img/mbloader.075226c1.gif";